import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-692c22ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "introduce-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "cr1" }, "本站介绍", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fz cr3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "cr6" }, "建站时间："),
  /*#__PURE__*/_createTextVNode("2021.10-2022.3")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fz cr3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "cr6" }, "前端技术：")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "开发框架："),
  /*#__PURE__*/_createTextVNode("Vue3 ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "脚手架："),
  /*#__PURE__*/_createTextVNode("Vue-cli4x ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "组件库："),
  /*#__PURE__*/_createTextVNode("Element-plus ")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "语法扩展："),
  /*#__PURE__*/_createTextVNode("TypeScript、Less ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "打包工具："),
  /*#__PURE__*/_createTextVNode("Webpack ")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "代码规范："),
  /*#__PURE__*/_createTextVNode("ESint、Prettier ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fz cr3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "cr6" }, "后端技术：")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "主语言："),
  /*#__PURE__*/_createTextVNode("JavaScript（Node.js） ")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "开发框架："),
  /*#__PURE__*/_createTextVNode("Express ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "数据库："),
  /*#__PURE__*/_createTextVNode("MongoDB ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "fz cr3",
  style: {"padding-left":"20px"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "文件存储："),
  /*#__PURE__*/_createTextVNode("云服务（宝塔面板） ")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fz cr3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "cr6" }, "本站介绍："),
  /*#__PURE__*/_createTextVNode("本站记录个人工作开发中遇到的问题以及解决方法 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "hover" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_divider),
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16
      ]),
      _: 1
    })
  ]))
}